import React from 'react';

const SubmitContext = React.createContext(() => {});
const RequestDetailsContext = React.createContext(() => {});
const EligibleItemsContext = React.createContext(() => {});
const SubAwardRecommendationContext = React.createContext(() => {});

export default {
  SubmitContext,
  RequestDetailsContext,
  EligibleItemsContext,
  SubAwardRecommendationContext,
};
